/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AccountDetailsQueryVariables = {};
export type AccountDetailsQueryResponse = {
    readonly account: {
        readonly isSelfIdentifiedAsSeniorCitizen: boolean | null;
        readonly " $fragmentRefs": FragmentRefs<"AccountSubtitle_account" | "AccountReadonlyContactDetails_account" | "AccountReadonlyAdditionalDetails_account" | "Addresses_account">;
    } | null;
    readonly configuration: {
        readonly " $fragmentRefs": FragmentRefs<"AccountReadonlyAdditionalDetails_configuration">;
    } | null;
    readonly features: {
        readonly isSelfIdentifyAsSeniorCitizenEnabled: boolean;
    } | null;
    readonly isSeniorCitizenLabel: {
        readonly " $fragmentRefs": FragmentRefs<"AccountReadonlyAdditionalDetails_isSeniorCitizenLabel">;
    } | null;
};
export type AccountDetailsQuery = {
    readonly response: AccountDetailsQueryResponse;
    readonly variables: AccountDetailsQueryVariables;
};



/*
query AccountDetailsQuery {
  account {
    ...AccountSubtitle_account
    ...AccountReadonlyContactDetails_account
    ...AccountReadonlyAdditionalDetails_account
    ...Addresses_account
    isSelfIdentifiedAsSeniorCitizen
    id
  }
  configuration {
    ...AccountReadonlyAdditionalDetails_configuration
  }
  features {
    isSelfIdentifyAsSeniorCitizenEnabled
  }
  isSeniorCitizenLabel: siteCustomisation(application: "licensing", name: "isSeniorCitizenLabel") {
    ...AccountReadonlyAdditionalDetails_isSeniorCitizenLabel
  }
}

fragment AccountReadonlyAdditionalDetails_account on Account {
  canDiscloseToPublic
  dateOfBirth
  driverLicence
  isSubscribedToShelterNewsletter
  isSelfIdentifiedAsSeniorCitizen
}

fragment AccountReadonlyAdditionalDetails_configuration on Configuration {
  ...Hideable_configuration
}

fragment AccountReadonlyAdditionalDetails_isSeniorCitizenLabel on SiteCustomisation {
  value
}

fragment AccountReadonlyContactDetails_account on Account {
  driverLicence
  dateOfBirth
  phoneNumbers {
    id
    type
    number
  }
}

fragment AccountSubtitle_account on Account {
  name
}

fragment Addresses_account on Account {
  physicalAddress {
    ...ReadonlyAddress_address
    id
  }
  mailingAddress {
    __typename
    ...ReadonlyAddress_address
    ... on LicensingDeliveryAddress {
      id
    }
    ... on LicensingStreetAddress {
      id
    }
  }
}

fragment Hideable_configuration on Configuration {
  hiddenFields
}

fragment ReadonlyAddress_address on LicensingMailingAddress {
  __isLicensingMailingAddress: __typename
  ... on LicensingAddress {
    __isLicensingAddress: __typename
    id
    suburb
    state
    postcode
    country
  }
  ... on LicensingDeliveryAddress {
    deliveryType {
      name
      id
    }
    deliveryNumber
  }
  ... on LicensingStreetAddress {
    addressLine
    jurisdiction {
      name
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSelfIdentifiedAsSeniorCitizen",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "concreteType": "Features",
        "kind": "LinkedField",
        "name": "features",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSelfIdentifyAsSeniorCitizenEnabled",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v2 = [
        {
            "kind": "Literal",
            "name": "application",
            "value": "licensing"
        } as any,
        {
            "kind": "Literal",
            "name": "name",
            "value": "isSeniorCitizenLabel"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "suburb",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postcode",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "DeliveryType",
        "kind": "LinkedField",
        "name": "deliveryType",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deliveryNumber",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addressLine",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "LicensingJurisdiction",
        "kind": "LinkedField",
        "name": "jurisdiction",
        "plural": false,
        "selections": [
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "AccountDetailsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AccountSubtitle_account"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AccountReadonlyContactDetails_account"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AccountReadonlyAdditionalDetails_account"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Addresses_account"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AccountReadonlyAdditionalDetails_configuration"
                        }
                    ],
                    "storageKey": null
                },
                (v1 /*: any*/),
                {
                    "alias": "isSeniorCitizenLabel",
                    "args": (v2 /*: any*/),
                    "concreteType": "SiteCustomisation",
                    "kind": "LinkedField",
                    "name": "siteCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AccountReadonlyAdditionalDetails_isSeniorCitizenLabel"
                        }
                    ],
                    "storageKey": "siteCustomisation(application:\"licensing\",name:\"isSeniorCitizenLabel\")"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AccountDetailsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "driverLicence",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dateOfBirth",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "LicensingAccountPhoneNumber",
                            "kind": "LinkedField",
                            "name": "phoneNumbers",
                            "plural": true,
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "number",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canDiscloseToPublic",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSubscribedToShelterNewsletter",
                            "storageKey": null
                        },
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "LicensingStreetAddress",
                            "kind": "LinkedField",
                            "name": "physicalAddress",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/)
                                            ],
                                            "type": "LicensingAddress",
                                            "abstractKey": "__isLicensingAddress"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v10 /*: any*/)
                                            ],
                                            "type": "LicensingDeliveryAddress",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v11 /*: any*/),
                                                (v12 /*: any*/)
                                            ],
                                            "type": "LicensingStreetAddress",
                                            "abstractKey": null
                                        }
                                    ],
                                    "type": "LicensingMailingAddress",
                                    "abstractKey": "__isLicensingMailingAddress"
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "mailingAddress",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isLicensingMailingAddress"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/)
                                    ],
                                    "type": "LicensingAddress",
                                    "abstractKey": "__isLicensingAddress"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v4 /*: any*/)
                                    ],
                                    "type": "LicensingDeliveryAddress",
                                    "abstractKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v4 /*: any*/)
                                    ],
                                    "type": "LicensingStreetAddress",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hiddenFields",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                (v1 /*: any*/),
                {
                    "alias": "isSeniorCitizenLabel",
                    "args": (v2 /*: any*/),
                    "concreteType": "SiteCustomisation",
                    "kind": "LinkedField",
                    "name": "siteCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                        }
                    ],
                    "storageKey": "siteCustomisation(application:\"licensing\",name:\"isSeniorCitizenLabel\")"
                }
            ]
        },
        "params": {
            "cacheID": "3f036c2d095cea0cc314a9b9e262f225",
            "id": null,
            "metadata": {},
            "name": "AccountDetailsQuery",
            "operationKind": "query",
            "text": "query AccountDetailsQuery {\n  account {\n    ...AccountSubtitle_account\n    ...AccountReadonlyContactDetails_account\n    ...AccountReadonlyAdditionalDetails_account\n    ...Addresses_account\n    isSelfIdentifiedAsSeniorCitizen\n    id\n  }\n  configuration {\n    ...AccountReadonlyAdditionalDetails_configuration\n  }\n  features {\n    isSelfIdentifyAsSeniorCitizenEnabled\n  }\n  isSeniorCitizenLabel: siteCustomisation(application: \"licensing\", name: \"isSeniorCitizenLabel\") {\n    ...AccountReadonlyAdditionalDetails_isSeniorCitizenLabel\n  }\n}\n\nfragment AccountReadonlyAdditionalDetails_account on Account {\n  canDiscloseToPublic\n  dateOfBirth\n  driverLicence\n  isSubscribedToShelterNewsletter\n  isSelfIdentifiedAsSeniorCitizen\n}\n\nfragment AccountReadonlyAdditionalDetails_configuration on Configuration {\n  ...Hideable_configuration\n}\n\nfragment AccountReadonlyAdditionalDetails_isSeniorCitizenLabel on SiteCustomisation {\n  value\n}\n\nfragment AccountReadonlyContactDetails_account on Account {\n  driverLicence\n  dateOfBirth\n  phoneNumbers {\n    id\n    type\n    number\n  }\n}\n\nfragment AccountSubtitle_account on Account {\n  name\n}\n\nfragment Addresses_account on Account {\n  physicalAddress {\n    ...ReadonlyAddress_address\n    id\n  }\n  mailingAddress {\n    __typename\n    ...ReadonlyAddress_address\n    ... on LicensingDeliveryAddress {\n      id\n    }\n    ... on LicensingStreetAddress {\n      id\n    }\n  }\n}\n\nfragment Hideable_configuration on Configuration {\n  hiddenFields\n}\n\nfragment ReadonlyAddress_address on LicensingMailingAddress {\n  __isLicensingMailingAddress: __typename\n  ... on LicensingAddress {\n    __isLicensingAddress: __typename\n    id\n    suburb\n    state\n    postcode\n    country\n  }\n  ... on LicensingDeliveryAddress {\n    deliveryType {\n      name\n      id\n    }\n    deliveryNumber\n  }\n  ... on LicensingStreetAddress {\n    addressLine\n    jurisdiction {\n      name\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '344335918cda9512faa68b8811710563';
export default node;
